<template>
  <tr class="pointer-events-none">
    <td>
      <div class="flex items-center gap-2 py-2">
        <div class="w-8 h-8 rounded bg-gray-200 animate-pulse" />
        <div class="h-4 w-64 rounded bg-gray-200 animate-pulse" />
      </div>
    </td>

    <td>
      <div class="h-4 w-24 rounded bg-gray-200 animate-pulse" />
    </td>

    <td>
      <div class="h-4 w-36 rounded bg-gray-200 animate-pulse" />
    </td>
  </tr>
</template>
